import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../src/assets/images/header-logo.svg'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "container container-nav" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "logo",
  class: "nav__logo"
}, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_NavMenu = _resolveComponent("NavMenu")
  const _component_controls_menu = _resolveComponent("controls-menu")
  const _component_Burger = _resolveComponent("Burger")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: '/' }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_NavMenu, {
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.openCloseMenu($event)), ["prevent"])),
        class: { nav__open: this.isOpen }
      }),
      _createVNode(_component_controls_menu),
      _createVNode(_component_Burger, {
        onClick: _cache[2] || (_cache[2] = _withModifiers($event => (this.isOpen = !this.isOpen), ["prevent"]))
      })
    ])
  ]))
}